import React, {useEffect} from "react";
import * as ReactDOM from "react-dom";
import NewsletterRegistrationInTextBlock from "./NewsletterRegistrationInTextBlock";
import NewsletterRegistrationFooterBlock from "./NewsletterRegistrationFooterBlock";
import window from "../lib/WindowExtended";
import {useCustomerSelector} from "../../store";
import NewsletterRegistrationBanner from "../organisms/newsletter/NewsletterRegistrationBanner";
import {RegistrationVoucher} from "../../helpers/registrationVoucher";
import NewsletterRegistrationFootnote from "./NewsletterRegistrationFootnote";

const isSubscriptionsView = new URLSearchParams(window.location.search).get("view") === "subscriptions";
const isNewsletterRegistrationPage = document.body.id.substring(1) === "118455";

const NewsletterRegistration: React.FC = () => {
  const {customer} = useCustomerSelector();
  const elements = document.getElementsByClassName("short-newsletter-block") as HTMLCollectionOf<HTMLDivElement>;

  useEffect(() => {
    if (
      !elements.length ||
      customer.newsletterFlag ||
      isSubscriptionsView ||
      isNewsletterRegistrationPage ||
      !RegistrationVoucher.rule
    ) {
      return;
    }
  }, []);

  // Only show when div is present (by 'CTA_EMAIL' pseudo tag, or above the footer)
  // and customer has no newsletter yet
  if (!elements.length || customer.newsletterFlag || isSubscriptionsView || isNewsletterRegistrationPage) {
    return null;
  }

  return (
    <React.Fragment>
      {Array.from(elements).map((element, index) => {
        const {place} = element.dataset;

        return ReactDOM.createPortal(<NewsletterRegistrationBlock key={index} place={place} />, element);
      })}
    </React.Fragment>
  );
};

export default NewsletterRegistration;

const NewsletterRegistrationBlock: React.FC<{place?: string}> = ({place}) => {
  if (place === "above-footer-new") {
    return (
      <>
        <NewsletterRegistrationBanner />
        <NewsletterRegistrationFootnote />
      </>
    );
  }

  return place === "in-text" ? (
    <NewsletterRegistrationInTextBlock />
  ) : (
    <>
      <NewsletterRegistrationFooterBlock />
      <NewsletterRegistrationFootnote />
    </>
  );
};
